import React from "react";
import _ from "lodash";
import HoverProperties from "../app2components/panel/shared/HoverProperties";

const ElementPropertiesHover = ({ elementType, hideColor, hover, onPropUpdate, isLocked }) => {
  const onHoverChange = (propInfo) => {
    if (onPropUpdate) {
      onPropUpdate(propInfo);
    }
  };

  return (
    <HoverProperties
      isLocked={isLocked}
      hoverPropName="hover"
      elementType={elementType}
      hideColor={hideColor}
      hover={hover}
      onPropUpdate={onHoverChange}
    />
  );
};

export default ElementPropertiesHover;
